import { AfterViewChecked, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { TableSection } from 'src/app/model/shared/table-section';

import { ModalComponent } from '../modal/modal.component';
import { documentToHtmlString } from '.';

@Component({
  selector: 'app-file-assets-table-section',
  templateUrl: './file-assets-table-section.component.html',
  styleUrls: ['./file-assets-table-section.component.scss']
})
export class FileAssetsTableSectionComponent implements OnInit, AfterViewChecked {
  @Input() tableSections: TableSection[] = [];

  @ViewChild('modal') modal!: ModalComponent;

  eventListenersAdded: boolean = false;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    // console.log('>>>> >>>> FileAssetsTableSectionComponent invoked ngOnInit');
    this.modal && this.modal.close();
    this.eventListenersAdded = false;
    // // console.log('ngOnInit eventListenersAdded : ', this.eventListenersAdded);
  }

  ngAfterViewChecked(): void {
    let elements = (<HTMLElement>this.elementRef.nativeElement).querySelectorAll('.xmlModal');

    // // console.log('elements : ', elements.length);

    if (elements.length > 0 && !this.eventListenersAdded) {
      this.eventListenersAdded = true;

      // // console.log('eventListenersAdded : ', this.eventListenersAdded);

      elements.forEach((element) =>
        this.renderer.listen(element, 'click', () => {
          // console.log('title : ', element.getAttribute('title'));
          this.modal.open(element.getAttribute('title') || '');
        })
      );
    }
  }

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }
}
